const pageErrorHandler = error => {
    if (error.code === 'ECONNABORTED') {
        return 'Your request timed out. Please refresh your browser or try again later.';
    } 
    else {
        return 'The server is having issues. Please try again later.';
    }
}

export default pageErrorHandler;